var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserRound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "user-round_svg__lucide user-round_svg__lucide-user-round"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 8,
  r: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 21a8 8 0 0 0-16 0"
})));
export { SvgUserRound as ReactComponent };
export default __webpack_public_path__ + "3e52288cb40dd561eb21c06f399db2cc.svg";